// ==== 型定義 ====
// interface Props {
//   newsContent: string;
// }

// ==== コンポーネント関数 ====
export default function NewsTelop({ newsContent }) {
  return (
  <aside
  role="complementary"
  aria-live="polite"
  className="w-[100dvw] text-[clamp(14px, 2vw, 16px)] text-center p-[0.5rem 0] text-[#fff] bg-[#7B45F0] tracking-[0.05em] whitespace-pre-line">
    <p dangerouslySetInnerHTML={{__html: newsContent}}/>
  </aside>);
}